import { fileSchema, locationSchema } from "@/types/schema";
import * as z from "zod";

export const messageInputSchema = z.object({
  comment: z.string().min(1, "Required"),
  files: fileSchema.array().nullish(),
  file: fileSchema.nullish(),
});

export type MessageInputSchemaModel = z.infer<typeof messageInputSchema>;

export const searchPinCodeSchema = z.object({
  postCode: z.string().optional(),
  location: locationSchema.optional(),
  countryCode: z.string().optional(),
  address: z.string().optional(),
});

export type SearchPinCodeSchemaModel = z.infer<typeof searchPinCodeSchema>;

export const locationInputSchema = z.object({
  locationDetail: z.string().optional(),
  radius: z.number().optional(),
  location: locationSchema.optional(),
});

export type LocationInputSchemaModel = z.infer<typeof locationInputSchema>;
